module.exports = __webpack_public_path__ + "static/media/12.ea302281.jpg";